import axios from "axios";

export async function getProspectsAndClients({ commit }) {
  try {
    const { data } = await axios.get(`user/count-data-by`);
    return data;
  } catch (e) {
    return e;
  }
}

export async function getProspectById({ commit }, id) {
  try {
    const { data } = await axios.get(`prospect/${id}`);
    return data;
  } catch (e) {
    return e;
  }
}

export async function getZipCode({ commit }, code) {
  try {
    const { data } = await axios.get(`zip-code-data/${code}`);
    return data;
  } catch (e) {
    return e;
  }
}

export async function createProspect({ commit }, payload) {
  try {
    const { data } = await axios.post(`prospect/create-prospect`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function deleteProspect({ commit }, payload) {
  try {
    const { data } = await axios.post(`prospect/delete-prospect`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function updateProspect({ commit }, payload) {
  try {
    const { data } = await axios.post(`prospect/update-prospect`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function makeClient({ commit }, payload) {
  try {
    const { data } = await axios.post(`prospect/make-client`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function getClients({ commit }, payload) {
  try {
    const { data } = await axios.post(`user/get-clients`, payload, {
      cancelToken: payload.source.token,
    });
    return data;
  } catch (e) {
    return e;
  }
}

export async function getProspects({ commit }, payload) {
  try {
    const { data } = await axios.post(`user/get-prospects`, payload, {
      cancelToken: payload.source.token,
    });
    return data;
  } catch (e) {
    return e;
  }
}

export async function getClientById({ commit }, payload) {
  try {
    const { data } = await axios.post(`user/get-client`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function updateClient({ commit }, payload) {
  try {
    const { data } = await axios.post(`prospect/update-client`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function getContacts({ commit }, payload) {
  try {
    const { data } = await axios.post(`user/get-contacts`, payload, {
      cancelToken: payload.source.token,
    });
    return data;
  } catch (e) {
    return e;
  }
}

export async function addOrRemoveFromFav({ commit }, payload) {
  try {
    const { data } = await axios.post(
      `user/add-or-remove-fav-clients`,
      payload
    );
    return data;
  } catch (e) {
    throw e;
  }
}

export async function getDistributors({ commit }, payload) {
  try {
    const { data } = await axios.post(`user/get-distributors`, payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function changeDistributor({ commit }, payload) {
  try {
    const { data } = await axios.post(`user/change-distributor`, payload);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function getZones({ commit }) {
  try {
    const { data } = await axios.get(`zone/`);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function sessionExpire({ commit }) {
  try {
    const { data } = await axios.post(`user/session-expire`);
    return data;
  } catch (e) {
    throw e;
  }
}

export async function createFarm({ commit }, payload) {
  try {
    const { data } = await axios.post(`prospect/create-farm`, payload);
    return data;
  } catch (e) {
    return e;
  }
}
